import moment from 'moment';
import 'moment-duration-format';
import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';

const safeFunction = <ReturnType,>(unsafe: () => ReturnType) => {
  return {
    unsafe,
    getOrElse: <FallbackType,>(fallback: () => FallbackType) => {
      try {
        return unsafe();
      } catch (e) {
        return fallback();
      }
    },
  };
};

const CALCULATE_EXPIRATION_TIMESTAMP_VERIFICATION_FRAGMENT = gql(`
  fragment calculateExpirationTimestamp_verification on Verification {
    unit
    quantity
  }
`);

export const calculateExpirationTimestamp = (
  verifiedAt: moment.MomentInput,
  {
    unit,
    quantity,
  }: DocumentType<typeof CALCULATE_EXPIRATION_TIMESTAMP_VERIFICATION_FRAGMENT>,
) => {
  return safeFunction(() =>
    moment(verifiedAt)
      .add(quantity, unit === 'MONTH' ? 'months' : 'weeks')
      .toISOString(),
  );
};

const HUMAN_READABLE_FREQUENCY_VERIFICATION_FRAGMENT = gql(`
  fragment humanReadableFrequency_verification on Verification {
    unit
    quantity
  }
`);

export const humanReadableFrequency = ({
  unit,
  quantity,
}: DocumentType<typeof HUMAN_READABLE_FREQUENCY_VERIFICATION_FRAGMENT>) => {
  if (quantity !== null && unit === 'MONTH') {
    const duration = moment.duration(quantity, 'months');
    return quantity > 12 && quantity % 12 > 0
      ? duration.format('y [years] [and] M [months]')
      : duration.format();
  }
  return moment.duration(quantity, 'weeks').format('w [weeks]');
};
